import { render } from "./ProtectForm.vue?vue&type=template&id=5e233ee4"
import script from "./ProtectForm.vue?vue&type=script&lang=js"
export * from "./ProtectForm.vue?vue&type=script&lang=js"

import "./ProtectForm.vue?vue&type=style&index=0&id=5e233ee4&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__